<ng-template #content let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h6 class="modal-title">{{'TITLE.TITLE_VISITOR_SEARCH' | translate}}</h6>
        <button type="button" class="close" aria-label="Close" (click)="onSelect(null);d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body container-fluid manualAssign">

        <div *ngIf="(!Model  || Model.TotalRecords == 0 ) && IsSubmitting == false" class="noRecords"><span translate>LBL.NO_RECORD_FOUND</span></div>

        <div class="row align-items-center" *ngIf="Model && ((IsLoaded && Model.length > 0) || Model.TotalRecords > 0)">
            <div class="col-auto mr-4" >
                <ngb-pagination [maxSize]="5" [rotate]="true" [collectionSize]="IsLoaded ? guestlst.length : Model.TotalRecords" [pageSize]="RequestModel.PageSize" [(page)]="RequestModel.PageNumber" [boundaryLinks]="true" (pageChange)="onPageChange()"></ngb-pagination>
            </div>
            <div class="col-auto" *ngIf="Model"><span translate>LBL.TOTAL_RECORDS</span>: <B>{{IsLoaded ? guestlst.length : Model.TotalRecords}}</B></div>
        </div>

        <sk-wave [isRunning]="IsSubmitting"></sk-wave>

        <div class="grdTable" *ngIf="IsSubmitting == false && Model && ((Model.Result != null && Model.Result.length > 0) || (Model.length > 0))">
                <div class="d-flex grdRow justify-content-between px-2">
                    <div class="grdCol label min-w-175">{{'LBL.LBL_FULL_NAME' | translate}}</div>
                    <div class="grdCol label min-w-175">{{'LBL.CONTACT_NO' | translate}}</div>
                    <div class="grdCol label min-w-175">{{'LBL.LBL_EMAIL' | translate}}</div>
                    <div class="grdCol label select-properties">{{'LBL.LBL_ACTION' | translate}}</div>
                </div>

            <div class="grdBodyScroll-Virtual overflow-auto" *ngIf="IsLoaded">
                <div *ngFor="let row of Model" class="d-flex grdRow justify-content-between px-2">
                    <div class="grdCol text-truncate min-w-175 max-w-175" title="{{row.VisitorName}}">{{row.VisitorName}}</div>
                    <div class="grdCol min-w-175">{{row.ContactNumber}}</div>
                    <div class="grdCol min-w-175">{{row.EmailId}}</div>
                    <div class="grdCol select-properties">
                        <button class="btn btn-link p-0" (click)="onSelect(row);" translate>
                            {{ "BTN.BTN_SELECT" }}
                        </button>
                    </div>
                </div>
            </div>
            <div class="grdBodyScroll-Virtual overflow-auto" *ngIf="!IsLoaded">
                <div *ngFor="let row of Model.Result" class="d-flex grdRow justify-content-between px-2">
                    <div class="grdCol text-truncate min-w-175 max-w-175" title="{{row.VisitorName}}">{{row.VisitorName}}</div>
                    <div class="grdCol min-w-175">{{row.ContactNumber}}</div>
                    <div class="grdCol min-w-175">{{row.EmailId}}</div>
                    <div class="grdCol select-properties">
                        <button class="btn btn-link p-0" (click)="onSelect(row);" translate>{{"BTN.BTN_SELECT" }}</button></div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal-footer">
        <button class="btn btn-secondary" type="button" (click)="onSelect(null);c('')" translate>BTN.BTN_CANCEL</button>
    </div>
</ng-template>